import { render, staticRenderFns } from "./RegisterAsAStudentPage.vue?vue&type=template&id=18dd93e5&scoped=true&"
import script from "./RegisterAsAStudentPage.vue?vue&type=script&lang=js&"
export * from "./RegisterAsAStudentPage.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAsAStudentPage.vue?vue&type=style&index=0&id=18dd93e5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dd93e5",
  null
  
)

export default component.exports